<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card title="3rd Party Sourced RMs">
        <template slot="actions">
          <vs-button @click="addNewRow" icon-pack="feather" icon="icon-plus" color="primary" type="filled">
            Add New
          </vs-button>
        </template>

        <vs-table stripe class="mt-8" :data="list">
          <template slot="thead">
            <vs-th>CODE</vs-th>
            <vs-th>NAME</vs-th>
            <vs-th width="10%">LIQUID CARRIER</vs-th>
            <vs-th width="10%">UNIT</vs-th>
            <vs-th width="10%">PRICE</vs-th>
            <vs-th width="10%">CURRENCY</vs-th>
            <vs-th>CREATED BY</vs-th>
            <vs-th width="10%">ACTIONS</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr v-for="(item, index) in list" :key="item.id">
              <vs-td>{{ item.code }}</vs-td>
              <vs-td>{{ item.name }}</vs-td>
              <vs-td>
                <vs-chip v-if="item.is_liquid" color="primary" transparent>
                  Yes
                </vs-chip>
              </vs-td>
              <vs-td>{{ item.unit }}</vs-td>
              <vs-td>{{ item.price }}</vs-td>
              <vs-td>{{ item.currency.code }}</vs-td>
              <vs-td>{{ item.created_by.name }}</vs-td>
              <vs-td>
                <vx-tooltip text="Update" position="left">
                  <vs-button @click.stop="editRow(item)" class="ml-3" size="small" color="warning" type="border"
                    icon-pack="feather" icon="icon-edit-2"></vs-button>
                </vx-tooltip>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <CreateSprayDryCarrierPopUp ref="createSprayDryCarrierPopUp" @refreshData="refreshData" />
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import CreateSprayDryCarrierPopUp from '@/components/popups/settings/spray-dry-carreir/CreateSprayDryCarrierPopUp.vue'

const SprayDryCostRepository = RepositoryFactory.get("spray_dry_cost");

export default {
  name: "SprayDryCarrier",
  data() {
    return {
      list: [],
      meta: null
    };
  },
  components: {
    CreateSprayDryCarrierPopUp
  },
  async mounted() {
    await this.getSprayDryCarriersList();
  },
  methods: {

    refreshData() {
      this.getSprayDryCarriersList();
    },

    async getSprayDryCarriersList() {
      const payload = (
        await SprayDryCostRepository.getSprayDryCarriersList()
      ).data;

      this.list = payload.data.sort((a, b) => a.order - b.order);
      this.meta = payload.meta;
    },

    addNewRow() {
      this.$refs.createSprayDryCarrierPopUp.openPopup();
    },

    editRow(item) {
      this.$refs.createSprayDryCarrierPopUp.openPopup(item.id);
    },

  },
};
</script>
